var amc=amc||{};if(!amc.on){amc.on=amc.call=function(){}};
document.write("<scr"+"ipt type=\"text/javascript\" src=\"//www.adobetag.com/d1/v2/ZDEtc29ueW5ldHdvcmtlbnRlcnRhaW5tZW50LTEyNDU3LTM3NjYt/amc.js\"></sc"+"ript>");



/**
 * this will be a wrapper for SiteCat
 * by default, it will run and just register page views, determining how to package them from the forum page it is on
 */
var s = s || {
	t : function() {
	}
};

var sui_sc = {
	pageTitle : null,
	btnPageTitle: null,
	server: "pdc",
	channel_type: "pdc_forum",
	channel_exceptions: [{"search":"Category:PSM Developer Forums","rep":"pss_dev_forum"}],
	params : {},
	pathStructure: null,
	readyToTrack: false,
	url_params : eM.getQueryString(),
	//keep the events here and map, this way if they change we don't need to change them everywhere
	//we can reference this object from anywhere that needs it
    events: {
        pageLoad                : 'event1',
        psnSignIn				: 'event3',
        AdorLinkImpression		: 'event5',
    	AdorLinkClickThrough	: 'event6',

        purchaseIntent          : 'event32',
        giveKudos				: 'event37',

        googlePlus              : 'event48',
        unclassSocial			: 'event46',
        facebookLike            : 'event48',
        twitterShare            : 'event48',
        emailOptIn              : 'event50',
        clickToPartnerEvent     : 'event54',
        retailerClickWhereToBuy : 'event61',
        event66                 : 'event66'
    },
    //the default tracking values
    defaultTrack: {
    	kind: 'o',
    	vars: [],
    	title: '',
    	events: [],
    	props: {},
    	evars: {},
    	a: null
    },
	linkTypes: {
		other: "o",
		exit: "e"
	},
	init : function() {
		var i = this;
		i.lPath = LITHIUM.CommunityJsonObject.WebTracking.path;
		i.working_ps = i.lPath.split("/");
		//if we are to use the channel exceptions
		//i.checkChannel();
		/*
		 * 	s is the sitecat object
		 */
		if (s) {
			//we get this so we can use it elsewhere without worring about live/stage or hardcoding etc
			i.scID = s.oun;
			var base = '';
			s.pageName = i.pageTitle = i.channel_type+i.getSubSection(1)+i.getSubSection(2)+i.getSubSection(3)+i.getSubSection(4);
			s.server = i.server;
			s.channel = i.channel_type+i.getSubSection(1,true);
			s.hier1 = "D=pageName";

			s.prop2 = i.getTerritory();
			if( i.getUserState() == 'signed_in' )
			{
				var userType = $( '#logged-in-user' ).attr( 'data-user-type' );
				s.prop3 = 'signed_in_' + userType;
			}
			else
			{
				s.prop3 = i.getUserState();
			}

			var prop10pageType = i.getPageType();

			if( prop10pageType == 'view-profile-page' )
			{
				prop10pageType = 'user profile';
			}

			s.prop10 = prop10pageType;
			s.prop47 = i.getDevice();
			s.prop50 = s.channel;
			if(i.getSubSection(2) !== ""){
				s.prop51 = i.channel_type+i.getSubSection(1)+i.getSubSection(2,true);
			}
			if(i.getSubSection(3) !== ""){
				s.prop52 = i.channel_type+i.getSubSection(1)+i.getSubSection(2)+i.getSubSection(3,true);
			}
			//s.prop53 = i.getSubSection(4,true);
			s.prop68 = window.location.href;
			s.prop72 = i.channel_type;

			s.eVar1 = "D=pageName";
			s.eVar2 = "D=c2";
			s.eVar3 = "D=c3";
			s.eVar10 = "D=c10";
			s.eVar47 = "D=c47";
			s.eVar50 = "D=c50";
			var e_list = [51,52,53];
			for(var k in e_list){
				if((typeof(s["prop"+k]) != eM.ud) && (s["prop"+k] != "")){
					s["eVar"+k] = "D=c"+k;
				}
			}

			s.eVar68 = "D=c68";
			s.eVar72 = "D=c72";
			i.addUserHash(s);
			s.events='event1';
			//check the login state

			if( $( '#PDC6-main-container' ).hasClass( 'thread' ) )
			{
				var boardName = $( '#topic-select-title' ).find( 'a' ).text();
	            var subject   = $( 'meta[property="og:title"]' ).attr( 'content' );
	            var prop20    = boardName.toLowerCase() + ':' + $.fn.SiteCatalyst.slugify( subject );

	            // Mauro B. dice di commentare questa stringa - Nic.
				//s.prop20 = $( '#topic-select-title' ).find( 'a' ).text();
				s.eVar20 = 'D=c20';
				s.prop20 = prop20;
				//s.eVar46 = 'D=c46';
				s.events = 'event1,event43';
			}

			s.timestamp = i.getTimeStamp();

			//we add this here to handle banner impressions, this way we only make one call to the sc servers
			event_tracking.bannerImpression(s);

			if((eM.getPageType(true) == "search") && (typeof(this.url_params['q']) != "undefined")){
				//on searchpage

				var event_list = [];
				//need to get count

				if ($.cookie('search_result_trigger_events')) {
					var value = $.cookie('search_result_trigger_events');

					s.prop17=this.url_params['q'].toLowerCase();
					s.eVar17 = "D=c17";

					$.removeCookie( 'search_result_trigger_events', { path : '/', domain : window.location.hostname });

					event_list.push('event17');

					var count = Number($(".search-result-count").children("b:eq(2)").text());
					if(count > 0){
						event_list.push("event18");
					} else {
						event_list.push("event19");

					}
				}

				s.prop65 = "pdc_forum";
				s.eVar65 = "D=c65";
				s.events = event_list.join(",");
				s.linkTrackVars = "";
			}

			if (window.sieeCanTrackUser && !sieeCanTrackUser()) {
                return;
            }

		    //console.log( s.events );
			s.t();
	        // s.linkTrackVars = "None";
	     	// s.linkTrackEvents = "None";
			//make pageview record
			//i.track({title:"Commerce Page View",events:[i.getEventCode("pageLoad")]});
			//i.search();
			if(typeof(i.sc_init_defer) != eM.ud){
				clearInterval(i.sc_init_defer);
			}
			i.readyToTrack = true;
			event_tracking.detectRussianFix();

		} else {
			//try deferring the load
			i.sc_init_defer = setInterval(function(){
				sui_sc.init();
			},100);
		}
	},
	getButtonPageName: function(){
		var i = this;
		if(i.btnPageTitle == null){
			i.btnPageTitle = i.pageTitle.replace(/:/g,"-");
		}
		return i.btnPageTitle;
	},
	getTimeStamp: function(){
		return Math.round((new Date()).getTime()/1000);
	},
	getEventCode : function(name){
		var i = this;
		if(i.events.hasOwnProperty(name)){
			return i.events[name];
		}
		return "key unknown";
	},
	getSCID : function() {
		return this.scID;
	},
	getDevice : function() {
		/*
		 * content devices:
		 * PS3/HD,
		 * PS3/SD,
		 * PSVita,
		 * PS4,
		 * PC,
		 * Tab,
		 * Mob
		 */
		return eM.getDevice();
	},
	getView : function() {
		/*
		 * view:
		 * WB = web browser
		 * AP = application
		 * FL = flash game
		 */
		return 'WB';
	},
	getSystem : function() {
		/*
		 * system:
		 * FB: Facebook
		 * MS: MicroSite
		 * Blog
		 * Forum
		 * FAQ
		 * PDC
		 */
		return 'Forum';
	},
	getPageType : function() {
		//board, thread etc
		var i = this;
		if (!i.getParam('page_type')) {
			i.params.page_type = eM.getPageType(true);
		}
		return i.params.page_type;
	},
	getDirStructure : function() {
		//this is the breadcrumb path to the page
		var i = this;
		if (!i.getParam('dir_structure')) {
			var dir = eM.getCoreNode();
			var crumbs = dir.ancestors.reverse();
			var dir_struct = '';

			//dir count
			var dc = crumbs.length;
			//we start from 1 - don't need to forum at 0
			for (var k = 0; k < dc; k++) {
				var join = '_';
				//console.log(crumbs[k].shortTitle);
				if (k == (dc - 1)) {
					join = '';
				}
				var add = crumbs[k].shortTitle;
				if (k == 0) {
					add = 'root';
				}
				dir_struct += add + join;
			}
			//console.log(dir_struct);

			i.params.dir_structure = dir_struct.toLowerCase();
		}
		return i.params.dir_structure;
	},
	getTerritory : function() {
		//eg scee-gb-en
		//not sure how to work this out, forum lookup table, or...
		//we need to make sure to mostly break ISO 639... dunno why
		/*
		var i = this;
		if (!i.getParam('terr')) {
			var l = eM.getLocaleAbs().toLowerCase().split("_");
			// console.log(l);
			switch(l[1]){
				case "au":
					i.params.terr = l[1] + "-" + l[0];
				break;

				default:
					i.params.terr = l[0];
				break;
			}
		}
		*/

		var parts  = window._currentLocaleCode.split( '_' )
		  , locale = parts[ 1 ] ? parts[ 1 ].toLowerCase() : parts[ 0 ];

		if( locale == 'au' )
		{
			locale = 'anz';
		}
		else if( locale == 'gb' )
		{
			locale = 'en';
		}

		this.params.terr = locale;

		return this.params.terr;
	},
	getBreadcrumbs : function() {
		return LITHIUM.CommunityJsonObject.WebTracking.path;
	},
	getPID : function() {
		//dunno
		var i = this;
		if (!i.params.hasOwnProperty('pid')) {

			var x = $('link[rel="canonical"]').attr("href").split("/");
			i.params.pid = x[x.length - 1];

			//now we pop off the last bit
		}
		return i.params.pid;
	},
	getPageTitle : function() {
		//EN:PC:WB:PDC:d_root:pt_home:t_Official PlayStation website
		var i = this;
		if (!i.getParam('page_title')) {
			var t = $("title").text();
			var t_s = t.replace(' - PlayStation Forum', '');
			t_s = t.replace(' - PlayStation Forum [STAGE]', '');
			i.params.page_title = $.trim(t_s);
			//we're going to pop off the last bit
		}
		return i.params.page_title;
	},
	getUTF8Length : function(txt) {

		var escapedStr = encodeURI(txt);
		if (escapedStr.indexOf("%") != -1) {
			var count = escapedStr.split("%").length - 1;
			if (count == 0) {
				count++;
			}
			var tmp = escapedStr.length - (count * 3);
			count = count + tmp;
		} else {
			count = escapedStr.length;
		}
		return count;
	},
	getParam : function(key) {
		var i = this;
		if (i.params.hasOwnProperty(key)) {
			return i.params[key];
		}
		return false;
	},
	// getCountryCode : function() {
		// //we can slot whatever into here, in this case, the eM
		// var i = this;
		// var v = i.getParam('locale');
		// if (!v) {
			// var l = eM.getLocale();
			// var e = l.split("_");
			// i.params.locale = e[0].toUpperCase();
		// }
		// return i.params.locale;
	// },
	prepText: function(txt){
		if(typeof(txt) == eM.ud){
			return "";
		}
		return $.trim(txt.toLowerCase().replace(/:/g,"-"));
	},

	getUserStatus : function()
	{
		if( eM.getUserState() == 'signed_in' )
        {
            var userType = $( '#logged-in-user' ).attr( 'data-user-type' );
            return 'signed_in_' + userType;
        }

        return eM.getUserState();
	},

	track: function(obj){

		var i = this;
		if(i.readyToTrack){
	 		for(var k in i.defaultTrack){
	 			if(typeof(obj[k]) == eM.ud){
	 				obj[k] = i.defaultTrack[k];
	 			}
	 		}
	 		s.trackExternalLinks 	= false;
	 		s.timestamp 			= i.getTimeStamp();
			s.events 				= s.linkTrackEvents = obj.events.join(",");
	        s.linkTrackVars   		= obj.vars.join(",") + ',prop75,eVar75,prop2,eVar2,prop3,eVar3';
	        for(var k in obj.props){
	        	s["prop"+k] = obj.props[k].replace("%btnTitle%",i.getButtonPageName());
	        }
	        for(var k in obj.evars){
	        	s["eVar"+k] = obj.evars[k].replace("%btnTitle%",i.getButtonPageName());
	        }
	        if(obj.hasOwnProperty("list1")){
	        	s.list1 = obj.list1.join(",");
	        }
	        // console.log(obj);

	        s.prop3 = this.getUserStatus();
            s.eVar3 = this.getUserStatus();

	        s.tl(false,obj.kind,obj.title);

	        s.linkTrackVars = "None";
	     	s.linkTrackEvents = "None";
		}

	},
	getUserState: function(){
		return eM.getUserState();
	},
	addUserHash: function(s){
		if((eM.getUserState() == "signed_in") && (typeof(pageData.hash) != eM.ud) && (pageData.hash != "")){
			s.prop75 = pageData.hash;
			s.eVar75 = "D=c75";
			s.visitorID = pageData.hash;
		}
	},
	checkChannel: function(){
		//most cases, we will need to be "pdc_forum", but there may be exceptions
		var i = this;


		//we now need to break this up
		var x_l = i.channel_exceptions.length;
		for(var x=0;x<x_l;x++){
			if(i.lPath.search(i.channel_exceptions[x].search) != -1){
				i.channel = i.channel_exceptions[x].rep;
				return;
			}
		}

	},
	getPathStructure: function(){
		//we need to pull this apart
		var i = this;

		if(i.pathStructure === null){
			i.pathStructure = {};

			var ps_count = i.working_ps.length;
			if(ps_count > 2){
				//we can now process the data
				var dir = eM.getCoreNode();
				var ancestors = dir.ancestors;
				var a = 1;
				for(var j=2;j<ps_count;j++){
					var index = "p"+a;
					i.pathStructure[index] = {};
					//now we modify the the entry in the list
					i.pathStructure[index].raw_label = i.working_ps[j];

					var working_wt_element = i.working_ps[j].substring(i.working_ps[j].indexOf(':')+1);
					//now we need to remove the extra text

					i.pathStructure[index].id = eM.lookupIdFromShortTitle(working_wt_element);
					i.pathStructure[index].label = working_wt_element.toLowerCase();
					//now we want to check the id, and see if we have a lookup for it

					var prefLabel = i.lookupPreferredLabelFromId(i.pathStructure[index].id);
					if(prefLabel != false){
						i.pathStructure[index].label = prefLabel.toLowerCase();
					}
					i.pathStructure[index].label;
					a++;
				}


			} else {
				//we're somewhere else, so we'll need to find out where
			}

		}
		return i.pathStructure;
	},
	lookupPreferredLabelFromId: function(id){
		if(typeof(sc_mapping) != eM.ud){
			if(typeof(sc_mapping[id]) != eM.ud){
				return sc_mapping[id];
			}
		}

		return id;
	},
	getSubSection: function(x,alone){

		if(typeof(alone) == eM.ud){
			alone = false;
		}
		var i = this;
		var u = eM.ud;
		var ps = i.getPathStructure();
		if(typeof(ps["p"+x]) != u){
			var append = "";
			// console.log("alone::"+x+" :: ",typeof(alone),alone,!alone);
			if((typeof(ps["p"+[x+1]]) != u) && (!alone)){
				append = ":";
			}
			var prephend = "";
			if((x==1)){

				prephend = ":";
			}
			return prephend+i.prepText(ps["p"+x].label)+append;
		}
		//exception for special pages
		var pDt = eM.getPageType(true)
		  , $mainContainer = $( '#PDC6-main-container' )
		if(x==1){
			switch(pDt){
				case "search":
				return ":"+pDt;
				break;
				case "view-profile-page":
				return ":"+pDt;
				break;
			}

			if( $mainContainer.hasClass( 'user-messages-compose' ) )
			{
				return ':privatenotespagecompose';
			}
			else if( $mainContainer.hasClass( 'user-messages-detail' ) )
			{
				return ':privatenotespagedetail';
			}
			else if( $mainContainer.hasClass( 'user-messages' ) )
			{
				return ':privatenotespage';
			}
			else if( $mainContainer.hasClass( 'notification-feed' ) )
			{
				return ':notificationfeedpage';
			}
			else if( $mainContainer.hasClass( 'view-profile-page' ) )
			{
				return ':userprofilepage';
			}
			else if( $mainContainer.hasClass( 'user-settings-page' ) || $mainContainer.hasClass( 'user-preferences' ) )
			{
				return ':usersettingspage';
			}

			return ":home";
		}
		return "";
	},
	handleSearchPage: function(){

	}

};
//extra bits for specific projects
sui_sc.search = function() {
	var i = this;
	i.checker = null;
	var x = {};



	x.a = {};

	x.a.params = {};
	x.searchResults = ".lia-autocomplete-content";
	x.container = $(".lia-autocomplete-container");
	x.searchHeader = ".lia-autocomplete-header";
	x.active = null;
	//x.searchHeaderDefault = x.searchHeader.text();
	x.searching = null;
	x.a.getUrlParams = function() {
		x.a.url = document.location.href;

		var url = x.a.url.split("#/?");
		if ( typeof url[1] == "undefined") {
			url = x.a.url.split("?");

		}
		if ( typeof url[1] != "undefined") {
			//we have a search done from the search page via ajax

			var innerUrlArr = url[1].split("&");
			for (k in innerUrlArr) {
				var hash = innerUrlArr[k].split("=");
				x.a.params[hash[0]] = hash[1];
			}
		}
	};
	x.checkSearch = function() {
		//we store the 'searching' version of the search header and reference it
		//work out which container is active
		x.container.each(function(){
			var t = $(this);
			if(t.css('display') != 'none'){
				x.active = t;
			}
		});
		if((x.searching == null) && (x.active != null)){
			//console.log(x.active.find(x.searchHeader));
			x.searching = x.active.find(x.searchHeader).text();
			x.results = x.active.find(x.searchResults);
		}
		//if we have results, we report that

		//if we don't, we report that


		//console.log('search checking running');
		//console.log(x);
		//we now keep running until we get a change in the response area

		//check the response area


		clearInterval(sui_sc.checker);
		this.relList = //this.searchResults.find("");

		length = x.results.find('li').size();
		//console.log(x.results);
		//console.log('checking: '+length);
		var search_events = ['event17', $( '.thread-search-results-list' ).find( '.lia-quilt-row' ).size() ? 'event18' : 'event19' ];
		this.a.getUrlParams();
		//console.log(this.a.params);
		if ((length != this.count) || (this.a.params['q'] != this.curSearch)) {
			this.curSearch = this.a.params['q'];
			this.count = length;
			//s.prop69 = length;
			//console.log('new search for '+this.a.params['q']+' found '+this.count);
			var found = '0';
			if (this.count > 0) {
				found = '1';
			} else {
				search_events.push('event19');
			}
            	 /*
            	 * prop17, eVar17 Internal Search Term
            	 * prop18, eVar18 Position of selected search result
            	 * prop68, eVar68 Search type: PDC, FAQs, Community
            	 * prop69, eVar69 Number of search results
            	 */

            	s.prop17 = this.a.params['q'];
            	s.eVar17 = "D=c17";
            	s.prop49 = 'search:field:topmodule:pdc_forum';
            	s.eVar49 = "D=c49";
            	s.linkTrackVars='prop17,prop75,eVar75,prop2,eVar2,eVar17,prop49,eVar49,events';
            	//search_events_joined
            	var sej = search_events.join(',');
				s.linkTrackEvents=sej;
				s.events=sej;
				s.tl(true,'o','search results');
		}
		//setTimeout(function(){x.checkSearch()}, 2000);
		//thread-search-results-list
	};
	x.benCheckSearch = function() {
		x.count = null;
		x.a.getUrlParams();
		x.curSearch = x.a.params['q'];
		x.checkSearch();
	};

	if (document.location.href.search('searchpage') != -1) {
		setTimeout(function(){x.benCheckSearch();}, 4000);
	}
	//the value can change in the same text box, so we need to do it on keys not focus
	$(".search-input").on('keyup',function(){
		if(i.checker == null){
			sui_sc.checker = setInterval(function(){x.checkSearch();},500);

		}
	});
};
